import DatePanel from '../DatePanel';
import { isInRange, isSameWeek } from '../../utils/dateUtil';
import classNames from '../../../_util/classNames';
import useMergeProps from '../../hooks/useMergeProps';
import { useInjectRange } from '../../RangeContext';
function WeekPanel(_props) {
    const props = useMergeProps(_props);
    const { prefixCls, generateConfig, locale, value } = props;
    // Render additional column
    const cellPrefixCls = `${prefixCls}-cell`;
    const prefixColumn = (date) => (<td key="week" class={classNames(cellPrefixCls, `${cellPrefixCls}-week`)}>
      <div class={`${cellPrefixCls}-inner`}>
        {generateConfig.locale.getWeek(locale.locale, date)}
      </div>
    </td>);
    const { rangedValue } = useInjectRange();
    // Add row className
    const rowPrefixCls = `${prefixCls}-week-panel-row`;
    const rowClassName = (date) => classNames(rowPrefixCls, {
        [`${rowPrefixCls}-selected`]: isSameWeek(generateConfig, locale.locale, value, date),
        [`${rowPrefixCls}-range-start`]: isSameWeek(generateConfig, locale.locale, rangedValue && rangedValue.value && rangedValue.value[0], date),
        [`${rowPrefixCls}-range-end`]: isSameWeek(generateConfig, locale.locale, rangedValue && rangedValue.value && rangedValue.value[1], date),
        [`${rowPrefixCls}-range-hover`]: isInRange(generateConfig, rangedValue && rangedValue.value && rangedValue.value[0], rangedValue && rangedValue.value && rangedValue.value[1], date),
    });
    return (<DatePanel {...props} panelName="week" prefixColumn={prefixColumn} rowClassName={rowClassName} keyboardConfig={{
            onLeftRight: null,
        }}/>);
}
WeekPanel.displayName = 'WeekPanel';
WeekPanel.inheritAttrs = false;
export default WeekPanel;
